import { useMemo } from 'react';

import {
  selectLocalOnlyEntries,
  useComposeSnapshotIndexStore,
} from '../../../store/ComposeSnapshotIndex';

export const useLocalDraftEntries = () => {
  const entriesBySessionId = useComposeSnapshotIndexStore(
    (state) => state.entriesBySessionId,
  );
  const openComposeSessionIds = useComposeSnapshotIndexStore(
    (state) => state.openComposeSessionIds,
  );
  const backgroundSavingSessionIds = useComposeSnapshotIndexStore(
    (state) => state.backgroundSavingSessionIds,
  );
  const syncingSessionIds = useComposeSnapshotIndexStore(
    (state) => state.syncingSessionIds,
  );
  const syncedDraftIdBySessionId = useComposeSnapshotIndexStore(
    (state) => state.syncedDraftIdBySessionId,
  );

  return useMemo(
    () =>
      selectLocalOnlyEntries(entriesBySessionId, {
        openComposeSessionIds,
        backgroundSavingSessionIds,
        syncingSessionIds,
        syncedDraftIdBySessionId,
      }),
    [
      entriesBySessionId,
      openComposeSessionIds,
      backgroundSavingSessionIds,
      syncingSessionIds,
      syncedDraftIdBySessionId,
    ],
  );
};

// A row whose save is in flight cannot be selected: deleting only its snapshot would orphan the draft the save is about to create.
export const useSelectableLocalDraftEntries = () => {
  const entries = useLocalDraftEntries();
  const syncingSessionIds = useComposeSnapshotIndexStore(
    (state) => state.syncingSessionIds,
  );

  return useMemo(
    () => entries.filter(({ sessionId }) => !syncingSessionIds[sessionId]),
    [entries, syncingSessionIds],
  );
};
